<template>
  <div style="min-height: 600px;width: 1200px;" class="mt-5 ml-auto mr-auto">
    <!--标题部分-->
    <public-title class="border-bottom">
      <span class="pr-1">酒店活动详情</span>
      <span class="text-muted h6">/THE&nbsp;&nbsp;DETAIL&nbsp;&nbsp;OF&nbsp;&nbsp;ACTIVITY</span>
      <span slot="right" class="w-70 d-flex justify-content-end">
        <el-button type="primary" @click="$router.back()">返回上一页</el-button>
      </span>
    </public-title>

    <div class="mt-3" id="activity_detail">
      <h4 class="text-center font-weight-bold">{{GetActivityInfo.title}}</h4>
      <div class="text-center mt-3"><span class="text-muted">发布时间：{{GetActivityInfo.time | formatTimestamp(1)}}</span>
      </div>
      <div class="mt-4">
        <p class="text-left"><span class="h5">活动时间：</span>{{GetActivityInfo.startdate | formatTimestamp() }}至
          {{GetActivityInfo.enddate | formatTimestamp()}}</p>
        <div id="content" v-html="GetActivityInfo.content" class="text-left mt-3">{{GetActivityInfo.content}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapActions, mapState} from 'vuex'

  export default {
    name: 'ActivityDetail',
    computed: {
      ...mapState(['GetActivityInfo']),
      queryId() {
        return this.$route.query.saleId;
      }
    },
    created() {
      this.GetActivityDetail({
        saleId: this.queryId
      });
    },
    methods: {
      ...mapActions(['GetActivityDetail']),
    }
  }
</script>
